"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogTitle = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const DialogTitle = ({
  content
}) => content && /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
  variant: "h5",
  component: "h2",
  textAlign: "center",
  children: content
});
exports.DialogTitle = DialogTitle;
